/* BOLD Daylight, content pages: reveal + count-up. Guarded, safe to load from several sections. */
(function () {
  'use strict';
  if (window.dlPages) return;
  window.dlPages = 1;
  document.documentElement.classList.add('dlp-js');

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(target)) return;
    var start = null, dur = 950;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.firstChild.nodeValue = String(Math.round(target * (0.5 - Math.cos(Math.PI * p) / 2)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function mark(el) {
    if (el.classList.contains('in')) return;
    el.classList.add('in');
    var counters = el.matches('[data-count]') ? [el] : [].slice.call(el.querySelectorAll('[data-count]'));
    counters.forEach(countUp);
  }

  function init() {
    var els = [].slice.call(document.querySelectorAll('.rv'));
    if (!els.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { mark(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      els.forEach(function (el) { io.observe(el); });
    }
    /* fallback so nothing stays hidden (suspended panes, old browsers) */
    setTimeout(function () { els.forEach(mark); }, 2400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
